import {computed} from "mobx";
import {EventTypeViewModel} from "./event-type-view-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {EventDomainModel} from "./event-domain-model";
import {MemberDomainModel} from "../../../yard/member/member-domain-model";
import {MemberViewModel} from "../../../yard/member/member-view-model";

export class EventViewModel extends BaseViewModel {
  domainModel: EventDomainModel;
  notInPlayTerm: String;

  constructor(domainModel: EventDomainModel, notInPlayTerm: String, isStaff) {
    super(domainModel);

    this.notInPlayTerm = notInPlayTerm;
    this.domainModel = domainModel;
    this.isStaff = isStaff;
  }

  @computed get player(): MemberViewModel {
    const player: MemberViewModel = this.domainModel && new MemberViewModel(this.domainModel.player);

    return player;
  }

  @computed get extraPlayers(): Array<MemberViewModel> {
    const extraPlayers: Array<MemberViewModel> = this.domainModel && this.domainModel.extraPlayers && this.domainModel.extraPlayers.map((player: MemberDomainModel) => new MemberViewModel(player));

    return extraPlayers;
  }

  @computed get eventType(): EventTypeViewModel {
    const eventType: EventTypeViewModel = this.domainModel && new EventTypeViewModel(this.domainModel.eventType);

    return eventType;
  }

  @computed get isMajor() {
    return this.domainModel.isMajor;
  }

  @computed get order() {
    return this.domainModel.order;
  }

  @computed get num() {
    return this.domainModel.num;
  }

  @computed get stageId() {
    return this.domainModel.stageId;
  }

  @computed get competitorId() {
    return this.domainModel.competitorId;
  }

  @computed get gameTime() {
    return this.domainModel.gameTime;
  }

  @computed get addedTime() {
    return this.domainModel.addedTime;
  }

  @computed get gameTimeDisplay() {
    return this.domainModel.gameTimeDisplay;
  }

  @computed get gameTimeAndStatusDisplayType() {
    return this.domainModel.gameTimeAndStatusDisplayType;
  }

  @computed get statusId() {
    return this.domainModel.statusId;
  }

  @computed get notInPlay(): Boolean {
    return this.domainModel.notInPlay;
  }

  @computed get subTitle(): Boolean {
    let subTitle: String = '';

    if (this.notInPlay) {
      subTitle = this.notInPlayTerm;
    } else if (this.extraPlayers?.length > 0) {
      subTitle = this.extraPlayers?.first().name;
    }

    return subTitle;
  }

  @computed get subsPlayerShortName(): String {
    return this.extraPlayers?.first()?.shortName || this.subTitle
  }

  get isNew(): Boolean {
    return this.domainModel.isNew;
  }
}
